module.exports = __webpack_public_path__ + "static/media/group-member-unselect.eefa6067.svg";